window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.settings = window.locales.am.settings || {};window.locales.am.settings.change_password = window.locales.am.settings.change_password || {};window.locales.am.settings.change_password = {...window.locales.am.settings.change_password, ...{
    "change_password": "የይለፍ ቃል ይለውጡ",           
    "password": "የይለፍ ቃል",           
    "re_type": "ደግመው ይጻፉ",           
    "password_updated": "የይለፍ ቃል በተሳካ ሁኔታ ዘምኗል።",           
    "try_again": "እባክዎ የይለፍ ቃልዎን እና ማረጋገጫዎን ይፈትሹ እና ደግመው ይሞክሩ።"           
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.settings = window.locales.ar.settings || {};window.locales.ar.settings.change_password = window.locales.ar.settings.change_password || {};window.locales.ar.settings.change_password = {...window.locales.ar.settings.change_password, ...{
    "password": "كلمة المرور",           
    "re_type": "إعادة الكتابة",           
    "password_updated": "تم تحديث كلمة المرور بنجاح.",           
    "try_again": "يرجى التحقق من كلمة المرور وتأكيدها والمحاولة مرةً أخرى.",           
    "change_password": "غير كلمة السر"
}
};window.locales.en = window.locales.en || {};window.locales.en.settings = window.locales.en.settings || {};window.locales.en.settings.change_password = window.locales.en.settings.change_password || {};window.locales.en.settings.change_password = {...window.locales.en.settings.change_password, ...{
    "change_password": "Change Password",
    "password": "Password",
    "re_type": "Retype",
    "password_updated": "Password successfully updated.",
    "try_again": "Please check your password and confirmation and try again."
}
};window.locales.es = window.locales.es || {};window.locales.es.settings = window.locales.es.settings || {};window.locales.es.settings.change_password = window.locales.es.settings.change_password || {};window.locales.es.settings.change_password = {...window.locales.es.settings.change_password, ...{
    "change_password": "Cambiar la contraseña",           
    "password": "Contraseña",           
    "re_type": "Volver a escribir",           
    "password_updated": "Contraseña actualizada correctamente.",           
    "try_again": "Por favor, verifica la contraseña y la confirmación y vuelve a intentarlo."           
}
};window.locales.it = window.locales.it || {};window.locales.it.settings = window.locales.it.settings || {};window.locales.it.settings.change_password = window.locales.it.settings.change_password || {};window.locales.it.settings.change_password = {...window.locales.it.settings.change_password, ...{
    "change_password": "Cambia password",           
    "password": "Password",           
    "re_type": "Digita nuovamente",           
    "password_updated": "Password aggiornata con successo.",           
    "try_again": "Per favore, ricontrolla la password e la conferma; quindi riprova."           
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.settings = window.locales.zh.settings || {};window.locales.zh.settings.change_password = window.locales.zh.settings.change_password || {};window.locales.zh.settings.change_password = {...window.locales.zh.settings.change_password, ...{
    "change_password": "更改密码",           
    "password": "密码",           
    "re_type": "重新键入",           
    "password_updated": "已成功更新密码。",           
    "try_again": "请检查您的密码和密码确认，然后重试。"           
}
};